<template>
  <v-app>
    <v-main>
      <v-app-bar
        v-if="$vuetify.breakpoint.mobile"
        dense
        fixed
        color="rgba(255, 255, 255, 0.5)"
      >
        <v-img
          src="../public/static/gdot-logo.png"
          class="shrink mr-2"
          width="110"
          contain
        />
        <v-spacer></v-spacer>
        <HelpText
          v-if="$vuetify.breakpoint.mobile"
          :slide-title="slideTitle"
          :help-text="helpText"
          :about-text="aboutText"
          :show-help-text="showHelpText"
          :show-about-text="showAboutText"
          :toggle-help-text="toggleHelpText"
          :toggle-about-text="toggleAboutText"
        />
        <v-app-bar-nav-icon @click="menu = true"></v-app-bar-nav-icon>
      </v-app-bar>
      <v-menu
        v-model="menu"
        min-width="50%"
        :position-x="1000"
        transition="scroll-y-transition"
        max-height="100vh"
      >
        <v-list dense nav>
          <v-list-item-group v-model="workShopSlide" color="primary" mandatory>
            <v-list-item
              v-for="(page, index) in slideLabels"
              :key="page"
              link
              @click="goToSlide(index)"
            >
              <v-list-item-content class="text-center">
                <v-list-item-title v-html="page"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-row>
        <v-col
          :cols="$vuetify.breakpoint.mobile ? `12` : `10`"
          style="overflow:hidden; padding: 0%"
        >
          <Workshop
            :work-shop-slide="workShopSlide"
            :help-text="helpText"
            :about-text="aboutText"
            :slide-title="slideTitle"
            :show-help-text="showHelpText"
            :show-about-text="showAboutText"
            :slide-visited="slideVisited"
            :get-slide-title="getSlideTitle"
            :get-slide-help-text="getSlideHelpText"
            :get-slide-about-text="getSlideAboutText"
            :toggle-help-text="toggleHelpText"
            :toggle-about-text="toggleAboutText"
            @update-slide="goToSlide"
          />
        </v-col>
        <v-col
          cols="2"
          v-if="!$vuetify.breakpoint.mobile"
          style="padding: 0% !important;"
        >
          <v-navigation-drawer
            right
            permanent
            color="rgba(255, 255, 255, 0.1)"
            width="100%"
          >
            <v-list dense nav>
              <v-list-item-group
                v-model="workShopSlide"
                color="primary"
                mandatory
              >
                <v-list-item
                  v-for="(page, index) in slideLabels"
                  :key="page"
                  link
                  @click="goToSlide(index)"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      :class="[
                        $vuetify.breakpoint.mdAndUp ? 'text-h4' : 'body-1'
                      ]"
                      v-html="page"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item-content
                  :style="{
                    'padding-top': $vuetify.breakpoint.mobile ? `0%` : `15%`
                  }"
                  :class="{ logos: !$vuetify.breakpoint.mobile }"
                >
                  <v-img
                    src="../public/static/gdot-logo.png"
                    :class="{ logoMobile: $vuetify.breakpoint.mobile }"
                  />
                </v-list-item-content>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>
        </v-col>
      </v-row>

      <!-- disabled - comment submission deadline passed -->
      <v-dialog width="50%" style="min-height: 50% !important;">
        <v-card>
          <v-container>
            <v-row>
              <v-col cols="12" class="text-center">
                <div>
                  <h3>
                    Thank you for touring our virtual meeting room space.
                    Remember to provide
                    <a
                      href="https://0014203-gdot.hub.arcgis.com/app/d294b6790e4b4ee082e1e91fb0b69332"
                      target="blank_"
                    >
                      submit comments
                    </a>
                    by December 15, 2020, for the project design or other
                    information presented at the virtual Public Information Open
                    House.
                  </h3>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import Workshop from "./components/Workshop.vue";
import HelpText from "@/components/HelpText.vue";

export default {
  name: "App",

  components: {
    Workshop,
    HelpText
  },
  // opted not to go this route (would be confusing for user)
  // created() {
  //   window.addEventListener("beforeunload", function(e) {
  //     let confirmationMessage = "Please leave a comment!"; //Not read in most browsers. needs to be non-empty
  //     (e || window.event).returnValue = confirmationMessage; //Gecko + IE
  //     return confirmationMessage; //Webkit, Safari, Chrome
  //   });
  // },
  props: {
    aboutIcon: {
      type: String,
      default: "mdi-account-question"
    },
    helpIcon: {
      type: String,
      default: "mdi-information"
    }
  },
  data: () => ({
    workShopSlide: 0,
    slideLabels: [
      "Project Design",
      // "Potential <br> Detours",
      "Environmental <br> Impacts",
      "Property <br> Acquisitions"
    ],
    menu: false,
    slideTitle: "",
    helpText: "",
    aboutText: "",
    showHelpText: true,
    showAboutText: false,
    slideVisited: [0, 0, 0]
  }),
  mounted() {
    this.getSlideTitle();
    this.getSlideHelpText();
    this.getSlideAboutText();
    this.slideVisited[this.workShopSlide] = 1;
  },
  watch: {
    workShopSlide() {
      this.getSlideTitle();
      this.getSlideHelpText();
      this.getSlideAboutText();
      this.$gtag.pageview({
        page_path: this.workShopSlide
      });
      if (!this.slideVisited[this.workShopSlide]) {
        this.showHelpText = true;
        this.slideVisited[this.workShopSlide] = 1;
      }
    }
  },
  methods: {
    goToSlide(slide) {
      this.workShopSlide = slide;
    },
    async getSlideHelpText() {
      const svg = await import(`@/data/slide${this.workShopSlide + 3}`);
      this.helpText = svg.default.helpText;
    },
    async getSlideAboutText() {
      const svg = await import(`@/data/slide${this.workShopSlide + 3}`);
      this.aboutText = svg.default.aboutText;
    },
    async getSlideTitle() {
      const svg = await import(`@/data/slide${this.workShopSlide + 3}`);
      this.slideTitle = svg.default.slideTitle;
    },
    toggleHelpText() {
      this.showHelpText = !this.showHelpText;
    },
    toggleAboutText() {
      this.showAboutText = !this.showAboutText;
    }
  }
};
</script>
<style scoped>
.logos {
  padding-left: 10%;
  padding-right: 10%;
}

.logoMobile {
  padding-left: 0;
  margin-left: -5%;
  margin-top: -5%;
  margin-bottom: -12%;
}
</style>
